<template>
  <v-container>
    <v-flex xs12 class="background">
      <v-toolbar height="56" color="primary">
        <v-toolbar-title id="idCabecalhoJanela" class="subheading white--text">
          Relação de Endossos
        </v-toolbar-title>
      </v-toolbar>
      <v-layout pa-5>
        <v-flex row wrap>
          N. COTAÇÃO
          <p>{{ formatarNumeroCotacao(endosso.numeroCotacao) }}</p>
        </v-flex>
        <v-flex row wrap>
          N. PROPOSTA / APÓLICE
          <p>{{endosso.numeroProposta}}</p>
        </v-flex>
        <v-flex>
          DIAS DE VIGÊNCIA APÓLICE
          <p>{{diasVigencia}}</p>
        </v-flex>
        <v-flex
          >RAZÃO SOCIAL
          <p>{{endosso.razaoSocial}}</p>
        </v-flex>
        <v-flex>
          CNPJ
          <p>{{endosso.cnpj}}</p>
        </v-flex>

        <v-flex>
          QTD. ÍTENS
          <p>{{quantItens}}</p>
        </v-flex>
        <br />
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
        <v-flex>
            VALOR
          <p></p>
        </v-flex>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
      </v-layout>
    </v-flex>

    <v-container pa-5 class="background data-table">
      <v-card elevation="0">
        <v-card-title>
          <v-flex xs12 sm11 md6 lg4>
            <v-btn
              v-if="filtroAtivado"
              color="primary"
              round
              dark
              @click="dialogFiltro = true"
            >FILTRO</v-btn>
            <v-btn
              v-else
              color="primary"
              round
              flat
              outline
              @click="dialogFiltro = true"
            >FILTRO</v-btn>
          </v-flex>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>

          <v-btn
            color="primary"
            :disabled="apoliceBloqueada"
            round
            dark
            @click="dialogRestituicao = true"
            >RESTITUIR</v-btn
          >

          <v-btn
            v-if="!selected"
            :disabled="apoliceBloqueada"
            color="primary"
            round
            dark
            @click="dialog = true"
            >NOVO ENDOSSO</v-btn
          >
        </v-card-title>
      </v-card>
      <template>
        <div class="table-width">
          <v-data-table
            :headers="headers"
            :items="endossoList"
            hide-actions
            :rows-per-page-items="[10]"
            item-key="item"
            class="elevation-0"
          >
            <template v-slot:items="props">

              <td
                v-for="([texto, atributos], index) in colunas(props.item)"
                :key="index"
                v-bind="atributos"
                :class="[' themeGrey--text click', ...(atributos.class || [])]"
                @click=" props.item.idTipoEndosso !== 2 ?
                  abrirEndosso(
                    props.item.numeroRevisao,
                    props.item.idTipoEndosso,
                    props.item.idRascunhoEndosso,
                    props.item.idStatusEndosso
                  ) : dialogRestituicao = true
                "
              >
                {{ texto }}
              </td>
              <td>
                <a class="btn-dialog-historico justify-content-center"  @click="abrirdialogHistorico(props.item.uuidRevisao, props.item.idRascunhoEndosso, props.item.numeroProposta, props.item.idStatusEndosso, props.item.numeroRevisao)">
                  Ver histórico
                </a>
              </td>
              <td>
                <v-btn class="btn-dialog-historico-erro" color="primary" :disabled="props.item.idStatusEndosso !== 5 " @click="abrirdialogHistoricoErro(props.item.numeroRevisao)">
              Ver Erros
            </v-btn>
              </td>
            </template>
          </v-data-table>
          <div class="text-xs-center pt-2">
            <v-pagination
              v-model="paginacao.page"
              :length="paginacao.totalPages"
              circle
            ></v-pagination>
          </div>
        </div>
      </template>
      <v-snackbar v-model="snack" :timeout="3000" :color="snackColor">
        {{ snackText }}
        <v-btn flat @click="snack = false">Fechar</v-btn>
      </v-snackbar>
    </v-container>
    <v-layout pt-5>
      <v-flex>
        <v-btn color="primary" @click="voltar" flat> Voltar </v-btn>
      </v-flex>
      <v-spacer></v-spacer>
    </v-layout>

    <template>
      <v-layout row justify-center>
        <v-dialog persistent v-model="dialog" max-width="600px" >
          <ModalEndossos
            v-if="dialog"
            :dialog="dialog"
            :idApolice="idApolice"
            :tipoEndossoList="listaTipoEndossos"
            :idPropostaStatus="idPropostaStatus"
            @fecharDialogoEndosso="dialog = false"
            @abrirEndossoCancelamento="dialog = false, dialogEndossoCancelamento = true"
          />
        </v-dialog>
      </v-layout>
    </template>

    <template>
      <v-layout row justify-center>
        <v-dialog persistent v-model="dialogRestituicao" max-width="800px" >
          <ModalRestituicao
          :dialog="dialogRestituicao"
          @fecharDialog="dialogRestituicao = false"
          @atualizar="buscarEndossos"
          />
          </v-dialog>
      </v-layout>
    </template>
    <template>
      <v-layout row justify-center>
        <v-dialog
          persistent
          v-model="dialogEndossoCancelamento"
          max-width="900px"
        >
          <ModalEndossoCancelamento
            v-if="dialogEndossoCancelamento"
            :dialog="dialogEndossoCancelamento"
            @fecharDialogEndossoCancelamento="dialogEndossoCancelamento = false"
            :idApolice="idApolice"
            @ativarLoader="ativarLoader"
            @desativarLoader="desativarLoader"


          />
          </v-dialog>
      </v-layout>
    </template>

    <template>
      <v-layout row justify-center>
        <v-dialog persistent v-model="dialogRestituicao" max-width="800px" >
          <ModalRestituicao
          :dialog="dialogRestituicao"
          @fecharDialog="dialogRestituicao = false"
          @atualizar="buscarEndossos"

          />
          </v-dialog>
      </v-layout>
    </template>
    <template>
      <v-layout row justify-center>
        <v-dialog
          persistent
          v-model="dialogHistorico"
          max-width="520px"
        >
         <ModalHistorico
            v-if="dialogHistorico"
            :dialog="dialogHistorico"
            @fecharDialogHistorico="dialogHistorico = false"
            :uuidRevisao="this.uuidRevisaoHistorico"
            :idRascunho="this.idRascunhoHistorico"
            :numeroProposta="this.numeroPropostaHistorico"
            :numeroRevisao="this.numeroRevisaoHistorico"
            :idStatus="this.statusPropostaHistorico"
            :endosso="true"
          />
        </v-dialog>
      </v-layout>
    </template>
    <template>
      <v-layout row justify-center>
        <v-dialog
          persistent
          v-model="dialogErros"
          max-width="520px"
        >
         <ModalHistoricoErro
            v-if="dialogErros"
            :dialog="dialogErros"
            @fecharDialogHistoricoErro="dialogErros = false"
            :endosso="true"
            :numeroRevisao="numeroRevisaoHistoricoErro"
          />
        </v-dialog>
      </v-layout>
    </template>
    <template>
      <v-dialog v-model="dialogFiltro" persistent width="300">
        <ModalFiltroEndosso
          :endossoStatusList="endossoStatusList"
          :tecnicoResponsavelList="tecnicoResponsavelList"
          :filtroAtivado="filtroAtivado"
          :dadosFiltroAtivado="modelFiltro"
          @formFiltroLimpo="dadosFiltroLimpados"
          @fecharModalFiltro="dialogFiltro = false"
          @filtrarDadosModal="tratamentoRequestFiltrarDados"
        >
        </ModalFiltroEndosso>
      </v-dialog>
    </template>
  </v-container>
</template>



<script>
import axios from "axios";
import { mapState } from "vuex";
import usuarioHelper from "@/helpers/usuario-logado.js";
import endossoApoliceHelper from "@/helpers/endosso-apolice.js";
import { adicionarId } from "@/helpers/url-helper.js";
import ModalEndossos  from './ModalEndosso.vue';
import ModalHistorico from "./ModalHistorico.vue";

import ModalEndossoCancelamento from "./ModalEndossoCancelamento.vue";
import ModalRestituicao from './ModalRestituicao.vue';
import ModalHistoricoErro from "./ModalHistoricoErro.vue";
import ModalFiltroEndosso from "./ModalFiltroEndosso.vue";


export default {
  name: "GridEndossos",
  components: {
    ModalEndossos,
    ModalRestituicao,
    ModalEndossoCancelamento,
    ModalHistorico,
    ModalHistoricoErro,
    ModalFiltroEndosso
  },
  data() {
    return {
      listaTipoEndossos: [],
      quantItens:null,
      diasVigencia: null,
      idApolice: null,
      filtrarErros: false,
      dialogFiltro: false,
      filtroAtivado: false,
      modelFiltro: {},
      endossoStatusList: [],
      tecnicoResponsavelList: [],
      dialogEndossoCancelamento: false,
      snack: false,
      snackColor: "",
      snackText: "",
      dialog: false,
      dialogAvaliando: false,
      dialogConfirmacao: false,
      dialogErros: false,
      dialogRestituicao: false,
      numeroPropostaHistorico: null,
      idRascunhoHistorico: null,
      selected: null,
      regras: {
        notNull: [(v) => !!v || "Você não pode deixar este campo em branco"],
      },
      filtro: {
        pesquisa: {
          opened: false,
          conteudo: "",
        },
        status: {
          selecionado: null,
        },
      },
      resultados: {
        totalPremio: null,
      },
      paginacao: {
        page: 1,
        size: 10,
        totalPages: 0,
      },
      endossoList: [],
      endosso: {},
      uuidRevisaoHistorico: null,
      statusPropostaHistorico: null,
      dialogHistorico: false,
      numeroRevisaoHistorico: null,
      numeroRevisaoHistoricoErro: null,

      headers: [
        { text: "N. COTAÇÃO ENDOSSO", value: "numeroCotacao" },
        { text: "N. DO ENDOSSO ESSOR", value: "numeroEndosso" },
        {
          text: "TÉCNICO RESPONSÁVEL ENDOSSO",
          value: "nomeTecnicoResponsavelEndosso"
        },
        {
          text: "SOLICITANTE",
          value: "nomeCorretorResponsavelEndosso"
        },
        { text: "N. PROPOSTA / ENDOSSO", value: "numeroProposta" },
        {
          text: "STATUS DO ENDOSSO",
          value: "idStatusEndosso",
          style: "width: 100px",
        },
        { text: "TIPO DO ENDOSSO", value: "idTipoEndosso" },
        { text: "TIPO DE OPERAÇÃO", value: "idTipoOperacao" },
        { text: "QTD. ÍTENS (INCLUS. / EXCLUS.)", value: "itemExcInc" },
        { text: "DATA DA PROPOSTA", value: "dataProposta" },
        { text: "INÍCIO VIGÊNCIA ENDOSSO", value: "dataInicio" },
        { text: "FIM VIGÊNCIA ENDOSSO", value: "dataFim" },
        { text: "VLR. ENDOSSO", value: "vlrEndosso" },
        {
          text: "VERSÃO",
          value: "versao",
        },
        { text: "Histórico de emissão", value:"historico" },
        { text: "HISTÓRICO ERROS", value:"historicoErros"},
      ],
      idPropostaStatus: null
    };
  },
  computed: {
    apoliceBloqueada() {
      const usuarioLogado = usuarioHelper.USUARIO_LOGADO();
      const idPerfilUsuario =
        usuarioLogado && usuarioLogado.perfil ? usuarioLogado.perfil.id : null;
      return endossoApoliceHelper.bloqueiaNovoEndosso(
        this.idPropostaStatus,
        idPerfilUsuario
      );
    },
  },
  watch: {
    "paginacao.page"() {
      if (this.filtroAtivado) {
        this.buscarEndossosFiltrados();
      } else {
        this.buscarEndossos();
      }
    },
    "paginacao.size"() {
      if (this.filtroAtivado) {
        this.buscarEndossosFiltrados();
      } else {
        this.buscarEndossos();
      }
    },
  },
  mounted() {
    this.$store.commit("formEndosso/limparTudo");
    this.idApolice = parseInt(this.$route.query.id);
    this.idPropostaStatus = this.$route.query.idPropostaStatus
      ? this.$route.query.idPropostaStatus
      : 1;
    this.retornarListagemEndossos();
    this.restaurarFiltroSalvo();
    this.buscarStatusEndossos();
    this.buscarTecnicosResponsaveis();

  },

  methods: {
    ativarLoader() {
      this.$store.commit("startLoading");
    },
    desativarLoader() {
      this.$store.commit("endLoading");
    },
    retornarListagemEndossos() {
      this.$store.commit("startLoading");
      axios.get(`${process.env.URL_ENDOSSOMS}/v1/retornaTipoEndossos/${this.idApolice}`, {
        headers: {
            Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`,
          }
      }).then(response => {
        return response.data;
      }).then(data => {
        this.listaTipoEndossos = data;
      }).catch(error => {
        if (error.response && error.response.data) {
            this.errorMessage =
              error.response.data.erros || error.response.data.message;
          } else {
            this.errorMessage = error.response.data.message;
          }
      })
      this.$store.commit("endLoading");

    },
    abrirdialog() {
      this.idApolice = this.selected;
      this.dialog = true;
    },

    abrirdialogHistorico(idRevisao, idRascunhoEndosso, numeroProposta, statusProposta, numeroRevisao ) {
       if( idRevisao != null ) {
        this.uuidRevisaoHistorico = idRevisao;
      } else if( idRascunhoEndosso != null ){
        this.idRascunhoHistorico = idRascunhoEndosso;
      }

      if( numeroProposta ) {
        this.numeroPropostaHistorico = numeroProposta.toString();
      } else {
        this.numeroPropostaHistorico = "0";
      }

      this.numeroRevisaoHistorico = numeroRevisao;
      this.statusPropostaHistorico = statusProposta;
      this.dialogHistorico = true;
    },
     abrirdialogHistoricoErro(numeroRevisao) {
      this.dialogErros = true;
      this.numeroRevisaoHistoricoErro = numeroRevisao;

    },
    fecharDialogHistoricoErro(){
      this.dialogErros = false;
    },
    fecharDialogHistorico(){
      this.dialogHistorico = false;
    },
    abrirEndosso(numeroRevisao, idTipoEndosso, idRascunhoEndosso, idStatusEndosso) {
      this.$router.push(
        `/GridPrincipal/InfoEndosso?id=${
          this.idApolice
        }&idStatusEndosso=${
          idStatusEndosso
        }&idTipoEndosso=${idTipoEndosso}${
          numeroRevisao ? `&numeroRevisao=${numeroRevisao}` : ''
        }${
          idRascunhoEndosso ? `&idRascunhoEndosso=${idRascunhoEndosso}` : ''
        }${
          this.idPropostaStatus ? `&idPropostaStatus=${this.idPropostaStatus}` : ''
        }`
      );
    },

    colunas(item) {
      return [
        [this.formatarNumeroCotacao(item.numeroRevisao), { class: "pa-4 text-align-center" }],
        [item.numeroEndosso || '-', { class: "pa-4 text-align-center" }],
        [item.nomeTecnicoResponsavelEndosso || '-', { class: "pa-4 text-align-center" }],
        [item.nomeCorretorResponsavelEndosso || '-', { class: "pa-4 text-align-center" }],
        [item.numeroProposta || '-', { class: "pa-4 text-align-center" }],
        [this.formatStatusEndosso(item.idStatusEndosso), { class: "pa-4 text-align-center" }],
        [this.formatTipoEndosso(item.idTipoEndosso), { class: "text-align-center" }],
        [this.formatTipoOperacao(item.idTipoEndosso), { class: "text-align-center" }],
        [item.itemExcInc || '-', { class: "text-align-center" }],
        [this.formatarData(item.dataProposta), { class: "text-align-center" }],
        [this.formatarData(item.dataInicio), { class: "text-align-center" }],
        [this.formatarData(item.dataFim), { class: "text-align-center" }],
        [this.formatMoney(item.vlrEndosso), { class: "text-align-center" }],
        [item.versao || '-', { class: "text-align-center" }],
      ];
    },
    contarData() {
      const dataAtual = new Date();
      const dataInicio = new Date(this.endosso.dataInicio);
      const contagem = dataAtual.getTime() - dataInicio.getTime();
      this.diasVigencia = Math.floor(contagem/(8.64e+7));
    },
    formatMoney(amount) {
      return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      }).format(amount || 0);
    },
    formatStatusEndosso(status) {
      if (status == 1) return "SALVO";
      if (status == 2) return "EMITIDA";
      if (status == 3) return "AG. ENDOSSO";
      if (status == 4) return "ENDOSSO APROVADO";
      if (status == 5) return "ENDOSSO REPROVADO";
      if(status == 8 ) return "PENDENTE"
      if(status == 9 ) return "RECUSADO"
    },
    formatTipoEndosso(tipo) {
      if (tipo == 1) return "COBRANÇA";
      if (tipo == 2) return "RESTITUIÇÃO";
      if (tipo == 3) return "SEM MOVIMENTAÇÃO";
      if (tipo == 4) return "CANCELAMENTO";
      if (tipo == 5) return "SUBSTITUIÇÃO";
      if (tipo == 6) return "ALTERAÇÃO";
      if (tipo == 7) return "GATILHO";
    },

    formatTipoOperacao(tipo){
      if (tipo == 1) return "COBRANÇA";
      if (tipo == 2) return "RESTITUIÇÃO";
      if (tipo == 3) return "EXCLUSÃO";
      if (tipo == 4) return "CANCELAMENTO";
      if (tipo == 5) return "SUBSTITUIÇÃO";
      if (tipo == 6) return "ALTERAÇÃO";
      if (tipo == 7) return "GATILHO";
    },

    buscarEndossos() {
      this.$store.commit("startLoading");
      axios
        .get(
          `${process.env.URL_ENDOSSOMS}/v1/listarEndossos/`+ this.idApolice + `/?page=${
            this.paginacao.page - 1
          }&size=${this.paginacao.size}`,
          {
            headers: {
              Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`,
            },
          }
        )
        .then((response) => {
          this.endossoList = response.data.content;
          if(response.data.content.length > 0){
            this.endosso = response.data.content[0];
            this.contarData();
            this.quantItens = this.somaNumeros(this.endossoList)
          }
          this.paginacao.totalPages = response.data.totalPages;
          this.$store.commit("endLoading");
        })
        .catch((err) => {
          this.$store.commit("endLoading");
        });
    },
    somaNumeros(numeros) {
      let soma = 0;
      for(let i = 0 ; i < numeros.length ; i++) {
        soma += numeros[i].itemExcInc
      } return soma
    },

    formatarCnpj(cnpj) {
      if (typeof cnpj === "string" && cnpj.match(/^[A-Za-z0-9]{12}\d{2}$/)) {
        return cnpj.replace(
          /^(.{2})(.{3})(.{3})(.{4})(.{2})$/,
          "$1.$2.$3/$4-$5"
        );
      }
      return "";
    },
    formatarData(data) {
      if (data) {
        return new Date(data).toLocaleDateString("pt-BR", {
          timeZone: "UTC",
          year: "numeric",
          month: "numeric",
          day: "numeric",
        });
      }
    },
    formatarNumeroItem(item) {
      const numero = `000${item}`;
      return numero.slice(numero.length - 3);
    },


    buscarStatusEndossos() {
      axios
        .get(`${process.env.URL_ENDOSSOMS}/v1/buscarListaStatusEndosso`, {
          headers: {
            Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
          }
        })
        .then(response => {
          this.endossoStatusList =
            response.data instanceof Array ? response.data : [];
        })
        .catch(err => {
          console.error(err);
        });
    },
    buscarTecnicosResponsaveis() {
      axios
        .get(`${process.env.URL_APOLICEMS}/v1/buscarTecnicosResponsaveisApolice`, {
          headers: {
            Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
          }
        })
        .then(response => {
          this.tecnicoResponsavelList =
            response.data instanceof Array ? response.data : [];
        })
        .catch(err => {
          console.error(err);
        });
    },
    restaurarFiltroSalvo() {
      const objetoSessionStorage = sessionStorage.getItem("filtroEndossoObjetoString");
      if (objetoSessionStorage != null) {
        const modeloFiltro = JSON.parse(objetoSessionStorage);
        const temFiltroStatus = Array.isArray(modeloFiltro.listaIdStatusEndosso) && modeloFiltro.listaIdStatusEndosso.length > 0;
        const temFiltroTecnico = Array.isArray(modeloFiltro.listaIdTecnicoResponsavelEndosso) && modeloFiltro.listaIdTecnicoResponsavelEndosso.length > 0;
        if (temFiltroStatus || temFiltroTecnico) {
          this.modelFiltro = {...modeloFiltro};
          this.filtroAtivado = true;
          this.buscarEndossosFiltrados();
          return;
        }
      }
      this.buscarEndossos();
    },
    tratamentoRequestFiltrarDados(val) {
      this.modelFiltro = {...val};
      this.filtroAtivado = true;
      this.paginacao.page = 1;
      this.buscarEndossosFiltrados();
    },
    dadosFiltroLimpados() {
      this.filtroAtivado = false;
      this.modelFiltro = {};
      this.dialogFiltro = false;
      sessionStorage.removeItem("filtroEndossoObjetoString");
      this.paginacao.page = 1;
      this.buscarEndossos();
    },
    buscarEndossosFiltrados() {
      this.$store.commit("startLoading");
      var requestBody = {
        listaIdStatusEndosso: this.modelFiltro.listaIdStatusEndosso || [],
        listaIdTecnicoResponsavelEndosso: this.modelFiltro.listaIdTecnicoResponsavelEndosso || [],
        listaIdTipoEndosso: this.modelFiltro.listaIdTipoEndosso || [],
        listaIdTipoCobertura: this.modelFiltro.listaIdTipoCobertura || [],
        numeroEndossoEssor: this.modelFiltro.numeroEndossoEssor || null,
        numeroCotacaoEndosso: this.modelFiltro.numeroCotacaoEndosso ? parseInt(this.modelFiltro.numeroCotacaoEndosso) : null
      };
      axios
        .post(
          `${process.env.URL_ENDOSSOMS}/v1/filtrarEndossos/${this.idApolice}?page=${
            this.paginacao.page - 1
          }&size=${this.paginacao.size}`,
          requestBody,
          {
            headers: {
              Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`,
            },
          }
        )
        .then((response) => {
          this.endossoList = response.data.content;
          if (response.data.content.length > 0) {
            this.endosso = response.data.content[0];
            this.contarData();
            this.quantItens = this.somaNumeros(this.endossoList);
          } else {
            this.endossoList = [];
            this.quantItens = 0;
          }
          this.paginacao.totalPages = response.data.totalPages;
          this.$store.commit("endLoading");
        })
        .catch((err) => {
          this.$store.commit("endLoading");
        });
    },

     voltar: function () {
      this.$router.push(
        adicionarId("/GridPrincipal/InfoGerais", this.idApolice)
      );
    },

    proximo() {
      const dadosAtualizados = {
        dados: this.dadosPlanilha,
      };
      this.$store.commit("formCotacao/setConteudoPlanilha", dadosAtualizados);
      this.$router.push(
        adicionarId("/GridPrincipal/Cobertura", this.idApolice)
      );
    },

    formatarNumeroCotacao(item) {
      if(item !=null) {
        const numero = `000000${item}`;
        return numero.slice(numero.length - 6);
      }
    }

  },
};
</script>

<style>
  .background {
    background-color: white;
  }

  .table-width > div > div > table {
    width: 3000px;
  }

  .item-color > div > a {
    color: #757575 !important;
  }

  .activeError {
    border: 1px solid red;
    color: red !important;
  }

  .button-permanecer {
    background: #00456e;
    color: white !important;
  }

  .text-permanecer {
    font-weight: bold;
    color: #757575 !important;
  }

  .errorTaxa {
    color: red !important;
    font-weight: bold;
  }

  .btn-dialog-historico {
    border: 0;
    background-color: transparent ;
    text-transform: uppercase ;
    text-align: center !important;
    color: #027DB4 ;
    box-shadow: none ;
  }
  .btn-dialog-historico:hover {
    text-decoration:underline;
  }

  .text-align-center {
    text-align: center;
  }

  .justify-content-center {
    display: flex;
    justify-content: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/frota/GridEndossos.vue